import React from 'react'
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles'
import { Box, Paper } from '@mui/material'
import classNames from 'classnames'
import Topbar from './topbar/Topbar'
import RoomInfo from './RoomInfo'
import RuleDisplay from './rule-display/RuleDisplay'
import Messages from './chat/Messages'
import Chat from './chat/Chat'
import ToggleLeft from './ToggleLeft'
import Teams from './players/Teams'
import Subactions from './subactions/Subactions'
import Actions from './actions/Actions'
import './Grid.scss'

const RoomBox = styled(Box)(
  ({ theme }) => `
  background-color: ${theme.palette.lightBack.secondary};
`
)

const Grid = ({ browser: { mobile }, showLeft }) => {
  const klass = classNames('grid-container', {
    mobile,
    'hide-left': !showLeft
  })

  return (
    <RoomBox className={klass}>
      <Box className="grid-topbar">
        <Topbar />
      </Box>
      <Paper className="grid-room-info">
        <RoomInfo />
      </Paper>
      <Paper className="grid-rule-display">
        <RuleDisplay />
      </Paper>
      <Paper className="grid-messages">
        <Messages />
      </Paper>
      <Paper className="grid-chat">
        <Chat />
      </Paper>
      <Box className="grid-toggle-left">
        <ToggleLeft />
      </Box>
      <Paper className="grid-teams">
        <Teams />
      </Paper>
      <Paper className="grid-subactions">
        <Subactions />
      </Paper>
      <Paper className="grid-actions">
        <Actions />
      </Paper>
    </RoomBox>
  )
}

export default connect(
  state => ({
    browser: state.browser,
    showLeft: state.appear.showLeft
  })
)(Grid)
